<p-toast />
<p-confirmDialog />
<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">{{ 'layout.configurations.technologies.title' | translate }}</p>
    <p-button
      *emPermission="Permission.CONFIG_STAFFING"
      class="p-button-success"
      icon="pi pi-plus"
      severity="success"
      (onClick)="onAdd()"
      >
    </p-button>
  </div>
  <p-table
    [value]="technologies"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    paginatorPosition="bottom"
    paginatorAlignment="center"
    styleClass="w-full p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="label" class="bg-white">
          {{ 'layout.configurations.technologies.label' | translate }} <p-sortIcon field="label" />
        </th>
      <th *emPermission="Permission.CONFIG_STAFFING" scope="col" class="bg-white w-10rem pl-3">
          {{ 'layout.configurations.technologies.actions' | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-technology>
      <tr>
        <td>{{ technology.label }}</td>
      <ng-container *emPermission="Permission.CONFIG_STAFFING">
          <td class="px-4 py-2 flex flex-row-reverse flex-wrap gap-2">
            <p-button
              icon="pi pi-pencil"
              [outlined]="true"
              class="mr-2"
              (onClick)="onEdit(technology)">
            </p-button>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [outlined]="true"
              (onClick)="onDelete($event, technology.id)">
            </p-button>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>

  <div class="mt-5">
    <div class="flex flex-column gap-1 mb-3">
      <p class="text-lg font-semibold m-0">
        {{ 'layout.configurations.technologies.otherSkillSuggestions.title' | translate }}
      </p>
      <span class="text-sm text-color-secondary">
        {{ 'layout.configurations.technologies.otherSkillSuggestions.description' | translate }}
      </span>
    </div>

    <p-table
      [value]="otherSkillSuggestions"
      [paginator]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
      paginatorPosition="bottom"
      paginatorAlignment="center"
      styleClass="w-full p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" pSortableColumn="label" class="bg-white">
            {{ 'layout.configurations.technologies.otherSkillSuggestions.skill' | translate }}
            <p-sortIcon field="label" />
          </th>
          <th scope="col" pSortableColumn="usageCount" class="bg-white">
            {{ 'layout.configurations.technologies.otherSkillSuggestions.usageCount' | translate }}
            <p-sortIcon field="usageCount" />
          </th>
          <th *emPermission="Permission.CONFIG_STAFFING" scope="col" class="bg-white w-10rem pl-3">
            {{ 'layout.configurations.technologies.actions' | translate }}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-suggestion>
        <tr>
          <td>{{ suggestion.label }}</td>
          <td>{{ suggestion.usageCount }}</td>
          <ng-container *emPermission="Permission.CONFIG_STAFFING">
            <td class="px-4 py-2">
              <p-button
                icon="pi pi-plus"
                [outlined]="true"
                severity="success"
                [loading]="promotingOtherSkill === suggestion.label"
                [label]="'layout.configurations.technologies.otherSkillSuggestions.promote' | translate"
                (onClick)="promoteOtherSkill(suggestion)">
              </p-button>
            </td>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center">
            {{ 'layout.configurations.technologies.otherSkillSuggestions.emptyMessage' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
